var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"csv-exporter"},[_c('button',{on:{"click":_vm.downloadCSV}},[_vm._v("Download CSV")])])}
var staticRenderFns = []

export { render, staticRenderFns }